// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"d2-z"};